import { styled } from '@mui/system';
import { Backdrop, Box } from '@mui/material';

export const Overlay = styled(Backdrop)({
  zIndex: 1300,
  color: '#fff',
});

export const ModalBox = styled(Box)({
  width: 400,
  backgroundColor: '#fff',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.3)',
  margin: 'auto',
});

export const Footer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: '20px',
});

export const ModalH2 = styled('h2')({
  marginBottom: '10px'
})